import React from "react";

import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Button from "@mui/material/Button";

import Styles from "./authn-error-styles";
import EnvService from "../../../services/env.service";
import { useLocation } from "react-router-dom";
import MarcaBB from "../../../assets/images/marca-bb.png";

export default function AuthNError() {
  const location = useLocation();
  const { REACT_APP_DYNAMIC_ERROR_URL } = EnvService.getEnv();

  const classes = Styles();
  const { error, providencia } = location?.state ?? {
    error: "Hmm, o acesso desse computador foi bloqueado por segurança.",
    providencia: "Entre em contato com sua agência para regularização.",
  };

  return (
    <Grid
      container
      justify="center"
      alignItems="center"
      className={classes.root}
    >
      <Grid item xs className={classes.content}>
        <Paper
          variant="elevation"
          elevation={0}
          className={classes.windowBackground}
        >
          <Grid item className={classes.logoBackground}>
            <img
              src={MarcaBB}
              alt="Banco do Brasil"
              className={classes.logoImg}
            />
          </Grid>
          <Grid className={classes.contentContainer}>
            <span className={classes.title}>Ops</span>
            <Grid>
              <p className={classes.atention}>{error}</p>
              <Grid>
                <p className={classes.message}>{providencia}</p>
              </Grid>
            </Grid>
          </Grid>
          <Grid className={classes.contentContainer}>
            <Button
              variant="contained"
              color="secondary"
              className={classes.buttonFooter}
              onClick={() => (window.location = REACT_APP_DYNAMIC_ERROR_URL)}
            >
              OK
            </Button>
          </Grid>
        </Paper>
      </Grid>
    </Grid>
  );
}
